import React from 'react';

const FeatureCallout = (props) => {
    let imgPath = props.app.config.assetsUrl + "/" + props.app.config.imageUrl;

    return (
        <div className="featured-feature">
            <div className="new-tag">
                New!
            </div>
            <div className="feature-content">
                <div className="feature-content-wrapper">
                    <div className="feature-icon">
                        <img height="50" width="auto" src={`${imgPath}/misc/instagram-color-icon-shadow.svg`}/>
                    </div>
                    <div className="feature-desc">
                        Auto post your Instagram Reels to all social media channels
                    </div>
                </div>
                <div className="feature-action">
                    <div className="feature-action-cta" onClick={props.onClick} role="button" aria-label='Share Instagram'>
                        Start sharing
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureCallout;